module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-09.4828dec4.jpg";